import { CommandSystem, CommandSystemDonate, CommandSystemExit, isCommandSystemDonate, isCommandSystemExit } from './framework/types/commands'
import { Bridge } from './framework/types/modules'

export default class FakeBridge implements Bridge {
  async send (command: CommandSystem): Promise<void> {
    if (isCommandSystemDonate(command)) {
      await this.handleDataSubmission(command)
    } else if (isCommandSystemExit(command)) {
      this.handleExit(command)
    } else {
      console.log('[FakeBridge] received unknown command: ' + JSON.stringify(command))
    }
  }

  async handleDataSubmission (command: CommandSystemDonate): Promise<void> {
    // Extract pid from URL query parameter
    const urlParams = new URLSearchParams(window.location.search);
    const pid = urlParams.get('pid');
    console.log(`[FakeBridge] Current URL: ${window.location.href}`);
    console.log(`[FakeBridge] URL search: ${window.location.search}`);
    console.log(`[FakeBridge] Extracted pid: ${pid}`);
    
    // Post the donation as the raw request body (key and pid in the URL),
    // so the server can stream it to disk instead of holding it in memory
    try {
      const params = new URLSearchParams({key: command.key});
      if (pid) {
        params.set('pid', pid);
      }
      const response = await fetch(`/data-submission?${params.toString()}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/octet-stream',
        },
        body: command.json_string,
      });

      if (!response.ok) {
        console.error(`[FakeBridge] Data submission failed with status: ${response.status}`);
      } else {
        console.log(`[FakeBridge] Data submission succeeded with status: ${response.status}`);
      }
    } catch (error) {
      console.error(`[FakeBridge] Error during data submission:`, error);
    }
  }

  handleExit (command: CommandSystemExit): void {
    console.log(`[FakeBridge] received exit: ${command.code}=${command.info}`)
  }
}
